export function scrollPageToTop() {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return;
  }

  // Route changes must not inherit the document’s smooth anchor scrolling.
  window.scrollTo({ top: 0, left: 0, behavior: "instant" });

  const root = document.scrollingElement;
  if (root) {
    root.scrollTop = 0;
    root.scrollLeft = 0;
  }

  document.documentElement.scrollTop = 0;
  document.documentElement.scrollLeft = 0;
  document.body.scrollTop = 0;
  document.body.scrollLeft = 0;

  document.querySelectorAll<HTMLElement>("[data-scroll-container]").forEach((container) => {
    container.scrollTo?.({ top: 0, left: 0, behavior: "instant" });
    container.scrollTop = 0;
    container.scrollLeft = 0;
  });
}